import { Center, Checkbox, Divider, Input, Table } from "@mantine/core";
import type { FormArrayElement, UseFormReturnType } from "@mantine/form";
import { Role, roleTranslations } from "../../models/enums/role";

export type AccessConfigFormType = {
  document_readable: Role[];
  document_signable: Role[];
};

type AccessConfigFormProps<T extends AccessConfigFormType> = {
  form: UseFormReturnType<T>;
  disabled?: boolean;
};

export function AccessConfigForm<T extends AccessConfigFormType>({ form, disabled = false }: AccessConfigFormProps<T>) {
  const findIndexByRole = (values: Role[], key: Role) => values.indexOf(key);

  const roleEntries = Object.values(Role)
    .filter((role) => role !== Role.ADMIN && role !== Role.COACH)
    .map((key) => (
      <Table.Tr key={key}>
        <Table.Th>{roleTranslations[key]}</Table.Th>
        <Table.Td>
          {/* biome-ignore lint/a11y/noLabelWithoutControl: mantine */}
          <label>
            <Center>
              <Checkbox
                checked={form.getValues().document_readable.includes(key)}
                onChange={(event) => {
                  if (event.currentTarget.checked) {
                    form.insertListItem("document_readable", key as FormArrayElement<T, "document_readable">);
                  } else {
                    form.setValues((prev) => ({
                      ...prev,
                      document_readable: prev.document_readable?.filter((role) => role !== key),
                      document_signable: prev.document_signable?.filter((role) => role !== key),
                    }));
                  }
                }}
                disabled={disabled}
              />
            </Center>
          </label>
        </Table.Td>
        <Table.Td>
          {/* biome-ignore lint/a11y/noLabelWithoutControl: mantine */}
          <label>
            <Center>
              <Checkbox
                checked={form.getValues().document_signable.includes(key)}
                onChange={(event) => {
                  if (event.currentTarget.checked) {
                    form.setValues((prev) => ({
                      ...prev,
                      document_readable: [...(prev.document_readable || []), key],
                      document_signable: [...(prev.document_signable || []), key],
                    }));
                  } else {
                    form.removeListItem("document_signable", findIndexByRole(form.getValues().document_signable, key));
                  }
                }}
                disabled={disabled}
              />
            </Center>
          </label>
        </Table.Td>
      </Table.Tr>
    ));
  return (
    <>
      <Divider />
      <Input.Label>Berechtigungen</Input.Label>
      <Table variant="vertical" layout="fixed" withColumnBorders verticalSpacing="sm" withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th />
            <Table.Th ta="center">Einsehbar</Table.Th>
            <Table.Th ta="center">Unterschrift benötigt</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{roleEntries}</Table.Tbody>
      </Table>
    </>
  );
}
